import { Icon } from "./Icons";

export default function SectionLabel({
  index,
  children,
}: {
  index: string;
  children: React.ReactNode;
}) {
  return (
    <div className="section-label mono">
      <span className="label-cross" aria-hidden="true">
        <Icon name="plus" />
      </span>
      <span>
        {index} / {children}
      </span>
    </div>
  );
}
